/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PatientListRowTherapist } from './patientListRowTherapist';
import { Patient } from './patient';
import { TreatmentTypeEnum } from './treatmentTypeEnum';


/**
 * Row of the patient list page: the patient plus the aggregates its columns derive from.  The aggregates are SQL annotations (``PatientQuerySet.with_*``) rather than a serialized appointment list — ``next_appointment`` in particular is the same value the list sorts by.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface PatientListRow { 
    patient: Patient;
    readonly nextAppointment: string | null;
    readonly plannedAppointmentCount: number;
    readonly treatmentTypes: Array<TreatmentTypeEnum>;
    therapist: PatientListRowTherapist | null;
}
export const PatientListRow_patient_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientListRow_nextAppointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientListRow_plannedAppointmentCount_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientListRow_treatmentTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const PatientListRow_therapist_Validators: ValidatorFn[] =
    [  Validators.required, ];


